import { render } from "./Pantry.vue?vue&type=template&id=82a76bde&scoped=true"
import script from "./Pantry.vue?vue&type=script&lang=js"
export * from "./Pantry.vue?vue&type=script&lang=js"

import "./Pantry.vue?vue&type=style&index=0&id=82a76bde&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82a76bde"]])

export default __exports__